export default length => value => {
  if (Array.isArray(value)) return value.length === 0 || value.length === length
  if(!/^[0-9]+$/.test(value)) return true

  return value === undefined || value === null
    ? true
    : value === '' || String(value).length === length
}





// WEBPACK FOOTER //
// ./src/custom_validators/numberLength.js